/** Typed application errors so the UI can react meaningfully. */

export class BexError extends Error {
  constructor(message, { code = 'BEX_ERROR', cause, recoverable = true, hint } = {}) {
    super(message);
    this.name = 'BexError';
    this.code = code;
    this.cause = cause;
    this.recoverable = recoverable;
    this.hint = hint;
  }
}

export class ProviderUnavailableError extends BexError {
  constructor(message, options = {}) {
    super(message, { code: 'PROVIDER_UNAVAILABLE', ...options });
    this.name = 'ProviderUnavailableError';
  }
}

export class ValidationError extends BexError {
  constructor(message, { issues = [], ...options } = {}) {
    super(message, { code: 'VALIDATION_ERROR', ...options });
    this.name = 'ValidationError';
    this.issues = issues;
  }
}

export class StorageError extends BexError {
  constructor(message, options = {}) {
    super(message, { code: 'STORAGE_ERROR', ...options });
    this.name = 'StorageError';
  }
}

export class CancelledError extends BexError {
  constructor(message = 'Cancelled') {
    super(message, { code: 'CANCELLED', recoverable: true });
    this.name = 'CancelledError';
  }
}

/** Normalise anything thrown into a BexError-shaped object. */
export function toBexError(error) {
  if (error instanceof BexError) return error;
  if (error?.name === 'AbortError') return new CancelledError(error.message);
  return new BexError(error?.message ?? 'Unknown error', { cause: error });
}

export function describeError(error) {
  const bex = toBexError(error);
  return {
    code: bex.code,
    message: bex.message,
    hint: bex.hint ?? null,
    recoverable: bex.recoverable,
    issues: bex.issues ?? [],
  };
}
